import React, { Component } from 'react'
import StatusPayment from './StatusPayment';
import { formatPrice } from '../../utils';

export default class StatusCreditCard extends Component {
    render() {
        const { purchase } = this.props;
        return (
            <StatusPayment purchase={purchase} theme="credit">
                <div className="credit">
                    <strong>Pagamento</strong>

                    <p>Cartão de crédito</p>

                    <div className="brand">
                        <img
                            src={`/assets/images/home/home/cards/${purchase.payment.brand}.svg`}
                            alt="brand"
                        />

                        <div className="infos-credit">
                            <span><b>{purchase.payment.brand}</b></span> (final {purchase.payment.number}) <br />
                            <strong>Pagamento</strong> {purchase.parcels}x de R$ {formatPrice(purchase.price / purchase.parcels)}
                        </div>
                    </div>
                    
                </div>
            </StatusPayment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/purchase_status/StatusCreditCard.jsx